/**
 * Prosumer Calculator - Wizard Types
 *
 * Navigation and state types for the 4-step prosumer wizard.
 * Independent of pro-calculator types.
 */

// ============================================================================
// WIZARD STEPS
// ============================================================================

/** 4-step wizard: Profile → Consumption → Devices → Results */
export type WizardStep = 'profile' | 'consumption' | 'devices' | 'results';

export const WIZARD_STEPS: WizardStep[] = [
  'profile',
  'consumption',
  'devices',
  'results',
];

export interface WizardStepConfig {
  key: WizardStep;
  label: string;
  description: string;
  icon: string; // Tabler icon name
}

export const STEP_CONFIG: WizardStepConfig[] = [
  {
    key: 'profile',
    label: 'Profil',
    description: 'Typ odbiorcy i dystrybutor',
    icon: 'IconHome',
  },
  {
    key: 'consumption',
    label: 'Zużycie',
    description: 'Dane o zużyciu energii',
    icon: 'IconBolt',
  },
  {
    key: 'devices',
    label: 'Urządzenia',
    description: 'PV, EV, pompa ciepła',
    icon: 'IconSolarPanel',
  },
  {
    key: 'results',
    label: 'Wyniki',
    description: 'Analiza i rekomendacja',
    icon: 'IconChartBar',
  },
];

// ============================================================================
// WIZARD NAVIGATION
// ============================================================================

export interface WizardNavigation {
  goToNextStep: () => boolean;
  goToPreviousStep: () => void;
  goToStep: (step: WizardStep) => void;
  restart: () => void;
}

// ============================================================================
// HELPERS
// ============================================================================

export function getStepIndex(step: WizardStep): number {
  return WIZARD_STEPS.indexOf(step);
}

export function getStepByIndex(index: number): WizardStep {
  return WIZARD_STEPS[index] ?? 'profile';
}
